import { render, staticRenderFns } from "./Quotation.vue?vue&type=template&id=022ef636&scoped=true"
import script from "./Quotation.vue?vue&type=script&lang=js"
export * from "./Quotation.vue?vue&type=script&lang=js"
import style0 from "./Quotation.vue?vue&type=style&index=0&id=022ef636&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022ef636",
  null
  
)

export default component.exports